import { TreeViewNode, TreeView } from '@fluid-experimental/tree';
import { MfsCollectionChange, MfsItemsChange, MfsPropertyChange, MfsRelationshipChange } from '../../..';

export type MfsChange =
  | (MfsItemsChange & { kind: 'itemsChanged' })
  | (MfsPropertyChange & { kind: 'propertyChanged' })
  | (MfsCollectionChange & { kind: 'collectionChanged' })
  | (MfsRelationshipChange & { kind: 'relationshipChanged' });

export type NodeGroup = { [key: string]: readonly TreeViewNode[] };

export type DeltaNodeGroup = { added: NodeGroup; changed: NodeGroup; removed: NodeGroup };

export type MatchFn = (view: TreeView, previousView: TreeView, delta: DeltaNodeGroup) => Match<MfsChange[]>;

export const enum MfsChangeCategory {
  Unknown,
  Items,
  Collection,
  Property,
  Relationship,
}

export type Match<T> = { isOK: true; value: T } | { isOK: false };

export const Match = {
  fail: <T>(): Match<T> => ({
    isOK: false,
  }),
  ok: <T>(value: T): Match<T> => ({
    isOK: true,
    value,
  }),
};
